var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDownSmall = function SvgChevronDownSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M1.934 3.334a.46.46 0 0 1 .65 0L5.05 5.762l2.39-2.428a.459.459 0 1 1 .648.65L5.336 6.735a.46.46 0 0 1-.65 0L1.935 3.983a.46.46 0 0 1 0-.649Z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronDownSmall;